module.exports = __webpack_public_path__ + "img/icon-code-94bc59b9.svg";